export const PEACEMAKER_TYPE = {
  PEACE: 10,
  SHARE: 11,
  VOLUNTEER: 12,
} as const

export type PEACEMAKERTypeCode = typeof PEACEMAKER_TYPE[keyof typeof PEACEMAKER_TYPE]

export const PEACEMAKER_TYPE_OPTIONS = [
  { code: PEACEMAKER_TYPE.PEACE, labelKey: '평화선언' },
  { code: PEACEMAKER_TYPE.SHARE, labelKey: '카드포스터공유' },
  { code: PEACEMAKER_TYPE.VOLUNTEER, labelKey: '봉사활동' },
] as const

export const PEACEMAKER_TYPE_DESC_KEYS: Record<PEACEMAKERTypeCode, string> = {
  [PEACEMAKER_TYPE.PEACE]: '평화선언으로가족친구동료와평화를약속하고br따뜻한일상을함께만들어가요',
  [PEACEMAKER_TYPE.SHARE]: '주위에카드를공유하고가정학교직장등에포스터를br공유해어머니사랑의언어를널리전해보세요',
  [PEACEMAKER_TYPE.VOLUNTEER]: '2026년은un세계자원봉사자의해2026입니다br어머니의마음으로이웃과지역사회를위한br봉사활동',
}

export const ACTIVITY_PEACEMAKER_GB = {
  HOME: 300,
  SCHOOL: 301,
  WORK: 302,
  OTHER: 303,
} as const

export type ActivityPEACEMAKERGbCode = typeof ACTIVITY_PEACEMAKER_GB[keyof typeof ACTIVITY_PEACEMAKER_GB]

export const ACTIVITY_PEACEMAKER_OPTIONS = [
  { code: ACTIVITY_PEACEMAKER_GB.HOME, labelKey: '가정' },
  { code: ACTIVITY_PEACEMAKER_GB.SCHOOL, labelKey: '학교' },
  { code: ACTIVITY_PEACEMAKER_GB.WORK, labelKey: '직장' },
  { code: ACTIVITY_PEACEMAKER_GB.OTHER, labelKey: '기타' },
] as const

export const ACTIVITY_DURATION_GB = {
  ONE_WEEK: 310,
  ONE_MONTH: 311,
  MORE_THAN_ONE_MONTH: 312,
} as const

export type ActivityDurationGbCode = typeof ACTIVITY_DURATION_GB[keyof typeof ACTIVITY_DURATION_GB]

export const ACTIVITY_DURATION_OPTIONS = [
  { code: ACTIVITY_DURATION_GB.ONE_WEEK, labelKey: '일주일' },
  { code: ACTIVITY_DURATION_GB.ONE_MONTH, labelKey: '한달' },
  { code: ACTIVITY_DURATION_GB.MORE_THAN_ONE_MONTH, labelKey: '한달이상' },
] as const

export const MATERIAL_TYPE_GB = {
  CARD: 320,  
  POSTER: 321,
} as const

export type MaterialTypeGbCode = typeof MATERIAL_TYPE_GB[keyof typeof MATERIAL_TYPE_GB]

export const MATERIAL_TYPE_OPTIONS = [
  { code: MATERIAL_TYPE_GB.CARD, labelKey: '카드' },
  { code: MATERIAL_TYPE_GB.POSTER, labelKey: '포스터' },
] as const
